import {
    Grid,
    TextField,
    InputAdornment,
    ClickAwayListener,
} from '@mui/material';
import type { GridSize } from '@mui/material';
import { useState, useEffect, useContext } from 'react';
import { AppContext } from '../all';

function convert(value: string) {
    if (value === undefined || value === null || value === '') {
        return '';
    }

    let result;
    if (Number.isNaN(Number(value))) {
        const number = parseFloat(value.replace(',', '.'));
        if (Number.isNaN(Number(number))) {
            result = '';
        } else {
            result = number.toFixed(2).toString().replace('.', ',');
        }
    } else {
        result = parseFloat(value).toFixed(2).toString().replace('.', ',');
    }

    return result;
}

type SttFormPriceProps = {
    grid?: boolean;
    caption: string;
    onChange: ({
        name,
        value,
    }: {
        name: string | undefined;
        value: unknown;
    }) => void;
    name: string;
    disabled?: boolean;
    defVal: string;
    xs?: GridSize;
    sm?: GridSize;
    md?: GridSize;
    lg?: GridSize;
    xl?: GridSize;
};

export function SttFormPrice({
    grid = false,
    xs = 6,
    sm = 6,
    md = 3,
    lg,
    xl,
    caption,
    onChange,
    defVal,
    name,
    disabled,
}: SttFormPriceProps) {
    const cxt = useContext(AppContext);
    const [val, setVal] = useState(defVal);
    const [displayVal, setDisplayVal] = useState(convert(defVal));
    const [valueChanged, setValueChanged] = useState(false);
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        if (!Number.isNaN(Number(defVal))) {
            setVal(defVal);
            if (!focused) {
                setDisplayVal(convert(defVal));
            }
        }
    }, [defVal]);

    useEffect(() => {
        if (focused) {
            setDisplayVal(val);
            setValueChanged(true);
        }
    }, [val]);

    function applyChange() {
        if (valueChanged) {
            setDisplayVal(convert(val));
            if (!name) return;
            onChange({ name, value: val });
            setValueChanged(false);
        }
    }

    const currencySymbol = cxt?.sc?.city?.country?.currencySymbol || '€';
    const content = (
        <ClickAwayListener onClickAway={() => focused && applyChange()}>
            <TextField
                fullWidth
                variant="outlined"
                label={caption}
                size="small"
                value={displayVal || ''}
                onChange={(e: any) => setVal(e.target.value)}
                onFocus={() => setFocused(true)}
                onBlur={() => {
                    setFocused(false);
                    applyChange();
                }}
                onKeyUp={(event: any) => {
                    if (event.key === 'Enter') {
                        applyChange();
                    }
                }}
                disabled={disabled}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {currencySymbol}
                        </InputAdornment>
                    ),
                }}
            />
        </ClickAwayListener>
    );

    return grid ? (
        <Grid size={{ xs, sm, md, lg, xl }}>{content}</Grid>
    ) : (
        content
    );
}
